// clients/laid-back-cycles/shopify/theme/assets/configurator-ui.js
(function () {
  'use strict';
  var E = window.LBCConfiguratorEngine;
  if (!E) { return; }

  function usd(n) {
    return '$' + Number(n).toLocaleString('en-US', { maximumFractionDigits: 0 });
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) { n.className = cls; }
    if (text != null) { n.textContent = text; }
    return n;
  }

  // Bottom edge of whatever is pinned across the top of the viewport — the theme's
  // sticky site header plus the sticky add-to-cart bar that appears on scroll — so an
  // opened section can land just beneath it instead of sliding behind it. Only counts
  // visible bars actually parked in the top band; returns 0 if nothing is pinned.
  function topStickyOffset() {
    var vh = window.innerHeight;
    var bottom = 0;
    var nodes = document.querySelectorAll('.shopify-section--header, .product-sticky-form');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      var cs = window.getComputedStyle(n);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') { continue; }
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) { continue; }
      var r = n.getBoundingClientRect();
      if (r.top < vh * 0.45 && r.bottom > 0 && r.bottom < vh * 0.6) {
        bottom = Math.max(bottom, r.bottom);
      }
    }
    return bottom;
  }

  function Configurator(root, config, isActive, assetBase) {
    this.root = root;
    this.config = config;
    this.assetBase = assetBase || '';
    this.selection = E.defaultSelection(config);
    this.active = !!isActive;
    // One accordion open at a time; all start closed on page load.
    this.openGroup = null;
    this.restore();
    this.render();
  }

  Configurator.prototype.optionImage = function (group, option) {
    var key = option.image || group.image || group.icon || null;
    return key ? (this.assetBase + key) : null;
  };

  Configurator.prototype.selectedOption = function (group) {
    var id = this.selection[group.id];
    return group.options.filter(function (o) { return o.id === id; })[0] || null;
  };

  Configurator.prototype.storageKey = function () {
    return 'lbc-config:' + this.config.id;
  };

  Configurator.prototype.restore = function () {
    var params = new URLSearchParams(window.location.search);
    var code = null;
    if (params.get('model') === this.config.id && params.get('build')) {
      code = params.get('build');
    } else if (!params.get('model')) {
      try { code = window.localStorage.getItem(this.storageKey()); } catch (e) {}
    }
    if (code) { this.selection = E.decodeSelection(this.config, code); }
  };

  Configurator.prototype.persist = function () {
    var code = E.encodeSelection(this.config, this.selection);
    try { window.localStorage.setItem(this.storageKey(), code); } catch (e) {}
    if (this.active) {
      var params = new URLSearchParams(window.location.search);
      params.set('model', this.config.id);
      params.set('build', code);
      history.replaceState(null, '', window.location.pathname + '?' + params.toString());
    }
  };

  Configurator.prototype.shareUrl = function () {
    var code = E.encodeSelection(this.config, this.selection);
    return window.location.origin + window.location.pathname +
      '?model=' + encodeURIComponent(this.config.id) + '&build=' + encodeURIComponent(code);
  };

  Configurator.prototype.dtsUrl = function () {
    var code = E.encodeSelection(this.config, this.selection);
    return '/pages/dream-trike-session?model=' + encodeURIComponent(this.config.id) +
      '&build=' + encodeURIComponent(code);
  };

  // Build the option-card grid for a single group (shared by plain groups and
  // the stacked sub-groups inside a folded section).
  Configurator.prototype.renderCards = function (g, disabled) {
    var self = this;
    var cfg = this.config;
    var grid = el('div', 'lbc-cfg__cards');
    g.options.forEach(function (o) {
      var card = el('button', 'lbc-cfg__card');
      card.type = 'button';

      var thumb = el('span', 'lbc-cfg__card-thumb');
      var src = self.optionImage(g, o);
      if (src) {
        var ci = el('img', 'lbc-cfg__card-img');
        ci.alt = o.label; ci.loading = 'lazy';
        ci.onerror = function () {
          thumb.classList.add('is-placeholder');
          if (ci.parentNode) { thumb.removeChild(ci); }
        };
        ci.src = src;
        thumb.appendChild(ci);
      } else {
        thumb.classList.add('is-placeholder');
      }
      card.appendChild(thumb);

      var text = el('span', 'lbc-cfg__card-text');
      text.appendChild(el('span', 'lbc-cfg__card-label', o.label));
      text.appendChild(el('span', 'lbc-cfg__card-price',
        o.price_delta ? '+' + usd(o.price_delta) : 'Included'));
      card.appendChild(text);

      if (self.selection[g.id] === o.id) { card.classList.add('is-selected'); }
      if (disabled[o.id]) { card.classList.add('is-disabled'); card.disabled = true; }
      card.addEventListener('click', function () {
        self.selection = E.select(cfg, self.selection, g.id, o.id);
        self.persist();
        self.render();
      });
      grid.appendChild(card);
    });
    return grid;
  };

  Configurator.prototype.sectionLabel = function (sectionId) {
    var map = this.config.sections || {};
    if (map[sectionId]) { return map[sectionId]; }
    return sectionId.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  };

  Configurator.prototype.render = function () {
    var self = this;
    var cfg = this.config;
    this.root.innerHTML = '';
    this.root.classList.toggle('is-active', this.active);

    // Section heading, ABOVE the warm panel (first thing in the mount).
    this.root.appendChild(el('h2', 'lbc-cfg__heading', 'Build Your Dream Trike'));

    // Warm panel card wrapping the whole UI (tabs/accordion + media + price bar).
    var shell = el('div', 'lbc-cfg__shell');

    var resolved = E.resolve(cfg, this.selection);
    this.selection = resolved.selection;
    var disabled = resolved.disabled;
    var hidden = resolved.hidden || {};

    // Left column: static model hero + price/cta bar.
    var media = el('div', 'lbc-cfg__media');
    var img = el('img', 'lbc-cfg__image');
    img.src = cfg.model_image; img.alt = cfg.title; img.loading = 'lazy';
    media.appendChild(img);

    // Right column: title + accordion of option groups.
    var panel = el('div', 'lbc-cfg__panel');
    panel.appendChild(el('h2', 'lbc-cfg__title', cfg.title));

    var acc = el('div', 'lbc-cfg__accordion');

    // Fold CONSECUTIVE visible groups sharing a `section` into one accordion item;
    // groups without a section stay standalone. Hidden groups are skipped entirely.
    var items = [];
    cfg.groups.forEach(function (g) {
      if (hidden[g.id]) { return; }
      var last = items[items.length - 1];
      if (g.section && last && last.section === g.section) {
        last.groups.push(g);
      } else {
        items.push({ section: g.section || null, groups: [g] });
      }
    });

    items.forEach(function (entry) {
      // The accordion id keys off the first (primary) sub-group so open-state and
      // section folding share the same contract.
      var primary = entry.groups[0];
      var itemId = primary.id;
      var isOpen = (self.openGroup === itemId);
      var item = el('div', 'lbc-cfg__group' + (isOpen ? ' is-open' : ''));
      var bodyId = 'lbc-cfg-' + cfg.id + '-' + itemId;

      var header = el('button', 'lbc-cfg__group-header');
      header.type = 'button';
      header.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      header.setAttribute('aria-controls', bodyId);
      var headerLabel = entry.section ? self.sectionLabel(entry.section) : primary.label;
      header.appendChild(el('span', 'lbc-cfg__group-label', headerLabel));
      // Collapsed value line reflects the primary sub-group's selection.
      var selOpt = self.selectedOption(primary);
      header.appendChild(el('span', 'lbc-cfg__group-value', selOpt ? selOpt.label : '—'));
      header.appendChild(el('span', 'lbc-cfg__chevron'));
      header.addEventListener('click', function () {
        // One group open at a time: opening a new group closes the others. Toggle
        // on the existing DOM (no full render() — that node rebuild is what made
        // the page jump). Heights now ANIMATE (see configurator.css), so opening and
        // closing are smooth — nothing collapses in a single frame, nothing to pop.
        var willOpen = (self.openGroup !== itemId);
        self.openGroup = willOpen ? itemId : null;
        var groups = acc.querySelectorAll('.lbc-cfg__group');
        for (var i = 0; i < groups.length; i++) { groups[i].classList.remove('is-open'); }
        var heads = acc.querySelectorAll('.lbc-cfg__group-header');
        for (var j = 0; j < heads.length; j++) { heads[j].setAttribute('aria-expanded', 'false'); }
        if (willOpen) {
          item.classList.add('is-open');
          header.setAttribute('aria-expanded', 'true');
        }

        // Bring the opened section's header to rest just below the pinned top bars
        // (site header + sticky add-to-cart), so the section reads from its top edge
        // down. We servo the header onto a PLANNED start→target glide: each frame we
        // measure where it actually is (the section above is still animating shut,
        // which keeps lifting it) and scroll exactly enough to drop it back onto the
        // planned curve. Because the plan is monotonic start→target, the header can
        // never move backwards — no overshoot, no pop — no matter what the height
        // animation does underneath, and there is no instant scroll for any browser to
        // flash. Open only.
        if (willOpen) {
          var scroller = document.scrollingElement || document.documentElement;
          var targetTop = topStickyOffset() + 10;
          var startTop = header.getBoundingClientRect().top;
          var savedBehavior = scroller.style.scrollBehavior;
          scroller.style.scrollBehavior = 'auto'; // our scroll is the ONLY motion
          var dur = 600; // matches the CSS grid-template-rows .6s so glide + height ease finish together
          var t0 = null;
          var ease = function (q) { return q < 0.5 ? 4 * q * q * q : 1 - Math.pow(-2 * q + 2, 3) / 2; };
          var servo = function (ts) {
            if (t0 === null) { t0 = ts; }
            var q = Math.min(1, (ts - t0) / dur);
            var planned = startTop + (targetTop - startTop) * ease(q);
            scroller.scrollTop += header.getBoundingClientRect().top - planned;
            if (q < 1) { requestAnimationFrame(servo); return; }
            scroller.scrollTop += header.getBoundingClientRect().top - targetTop; // settle exactly
            scroller.style.scrollBehavior = savedBehavior;
          };
          requestAnimationFrame(servo);
        }
        self.persist();
      });
      item.appendChild(header);

      var body = el('div', 'lbc-cfg__group-body');
      body.id = bodyId;
      body.setAttribute('role', 'region');
      // grid(body) > clip(overflow:hidden, collapses to 0) > inner(padding/content).
      // The clip layer must stay padding-free so grid-template-rows:0fr can flatten it
      // completely; the padded content lives inside it and hides with it.
      var clip = el('div', 'lbc-cfg__group-body-clip');
      var inner = el('div', 'lbc-cfg__group-body-inner');
      if (entry.section) {
        // Stacked sub-groups, each headed by its own label.
        entry.groups.forEach(function (sub) {
          var block = el('div', 'lbc-cfg__subgroup');
          block.appendChild(el('h4', 'lbc-cfg__subgroup-label', sub.label));
          block.appendChild(self.renderCards(sub, disabled));
          inner.appendChild(block);
        });
      } else {
        inner.appendChild(self.renderCards(primary, disabled));
      }
      clip.appendChild(inner);
      body.appendChild(clip);
      item.appendChild(body);
      acc.appendChild(item);
    });
    panel.appendChild(el('p', 'lbc-cfg__disclaimer',
      "Prices are estimates to help you plan your build. We confirm your final quote with the manufacturer before anything's ordered."));
    panel.appendChild(acc);
    panel.appendChild(this.renderShare());

    // Price + CTA bar lives in the left column (sticky on desktop, bottom-fixed on mobile).
    var bar = el('div', 'lbc-cfg__bar');
    var price = el('div', 'lbc-cfg__price');
    price.appendChild(el('span', 'lbc-cfg__price-label', 'Your Build Estimate:'));
    price.appendChild(el('span', 'lbc-cfg__price-value', usd(E.totalPrice(cfg, this.selection))));
    bar.appendChild(price);
    bar.appendChild(this.renderResult());
    media.appendChild(bar);

    // Two-column layout lives inside the warm panel shell.
    var layout = el('div', 'lbc-cfg__layout');
    layout.appendChild(media);
    layout.appendChild(panel);
    shell.appendChild(layout);
    this.root.appendChild(shell);
    this.persist();
  };

  // The yellow DTS button + descriptor — lives in the left price/cta bar.
  Configurator.prototype.renderResult = function () {
    var wrap = el('div', 'lbc-cfg__result');
    var dts = el('a', 'lbc-cfg__cta');
    dts.href = this.dtsUrl();
    dts.textContent = 'Book a Dream Trike Call';
    wrap.appendChild(dts);
    wrap.appendChild(el('p', 'lbc-cfg__dts-note',
      "Your chance to ask questions, make sure it's the right fit, and actually order your trike."));
    return wrap;
  };

  // Copy-build-link — lives on the right, beneath the accordion tabs.
  Configurator.prototype.renderShare = function () {
    var self = this;
    var share = el('div', 'lbc-cfg__share');
    var copy = el('button', 'lbc-cfg__share-btn', 'Copy build link');
    copy.type = 'button';
    copy.addEventListener('click', function () {
      var url = self.shareUrl();
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          copy.textContent = 'Link copied';
          setTimeout(function () { copy.textContent = 'Copy build link'; }, 2000);
        });
      } else { window.prompt('Copy this build link:', url); }
    });
    share.appendChild(copy);
    return share;
  };

  function init() {
    var data = Array.prototype.slice.call(
      document.querySelectorAll('script.lbc-configurator-data'));
    if (!data.length) { return; }

    var mount = document.querySelector('[data-lbc-configurator-mount]');
    if (!mount) { return; }

    // Hand scroll control to the accordion's own header-pinning (see the toggle
    // handler). The browser's native scroll anchoring otherwise fights the pin and
    // the two corrections stack into a bounce. Disable it on every element that
    // could be the scroll container (themes vary: html, body, or scrollingElement),
    // so the pin is the ONLY thing adjusting scroll. Scoped to configurator pages.
    [document.documentElement, document.body, document.scrollingElement].forEach(function (n) {
      if (n) { n.style.overflowAnchor = 'none'; }
    });

    var assetBase = mount.getAttribute('data-cfg-asset-base') || '';

    var configs = data.map(function (s) {
      return { config: JSON.parse(s.textContent), active: s.getAttribute('data-active') === 'true' };
    });

    // Model picker when there is more than one model (hub mount).
    var instances = [];
    var panels = el('div', 'lbc-cfg__panels');

    function activate(i) {
      instances.forEach(function (inst, j) {
        inst.cfg.active = (i === j);
        inst.panel.style.display = (i === j) ? '' : 'none';
        inst.cfg.active && inst.cfg.persist ? null : null;
      });
    }

    if (configs.length > 1) {
      var picker = el('div', 'lbc-cfg__picker');
      configs.forEach(function (c, i) {
        var b = el('button', 'lbc-cfg__picker-btn', c.config.title);
        b.type = 'button';
        b.addEventListener('click', function () {
          instances.forEach(function (inst, j) {
            var on = (i === j);
            inst.panel.style.display = on ? '' : 'none';
            inst.configurator.active = on;
            if (on) { inst.configurator.persist(); inst.configurator.render(); }
          });
          Array.prototype.forEach.call(picker.children, function (c2, j) {
            c2.classList.toggle('is-active', i === j);
          });
        });
        picker.appendChild(b);
      });
      mount.appendChild(picker);
    }

    configs.forEach(function (c, i) {
      var panel = el('div', 'lbc-cfg');
      var active = configs.length === 1 ? true : (c.active || i === 0);
      panel.style.display = active ? '' : 'none';
      var configurator = new Configurator(panel, c.config, active, assetBase);
      panels.appendChild(panel);
      instances.push({ panel: panel, configurator: configurator });
    });
    mount.appendChild(panels);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
